var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSleep = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-sleep_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161152",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31304"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31303",
  clipPath: "url(#icon-sleep_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38587",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31306"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31305",
  clipPath: "url(#icon-sleep_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38588",
  d: "M48.492 40.181a18.079 18.079 0 01-24.376-24.376h-.253a18.076 18.076 0 1024.375 24.376",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38589",
  d: "M32.312 50.915a19.025 19.025 0 01-8.761-35.905.944.944 0 01.87 1.675 17.134 17.134 0 007.891 32.343 17.158 17.158 0 0015.21-9.239.944.944 0 011.675.871 19.046 19.046 0 01-16.884 10.256z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38590",
  d: "M40.015 43.218a19.044 19.044 0 01-16.863-27.806.944.944 0 111.675.87 17.135 17.135 0 0023.1 23.1.944.944 0 01.87 1.675 19.029 19.029 0 01-8.782 2.161z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38591",
  d: "M39.682 24.651h-8.028a.944.944 0 01-.725-1.548l6.778-8.132h-6.092a.944.944 0 010-1.887h8.105a.944.944 0 01.725 1.548l-6.778 8.132h6.013a.944.944 0 010 1.887z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38592",
  d: "M49.73 31.609h-5.735a.944.944 0 01-.725-1.548l4.473-5.367h-3.775a.944.944 0 110-1.887h5.79a.944.944 0 01.725 1.548l-4.472 5.366h3.72a.944.944 0 110 1.887z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38593",
  d: "M39.482 35.065h-4.03a.944.944 0 01-.725-1.548l2.759-3.311h-2.053a.944.944 0 010-1.887h4.068a.944.944 0 01.725 1.548l-2.759 3.311h2.015a.944.944 0 110 1.887z",
  fill: "#283c8c"
})))));
export default __webpack_public_path__ + "static/icon-sleep.c21282fa9094b4c7af7f054c827391ff.svg";
export { SvgIconSleep as ReactComponent };